export const formatearDecimal = function (val, cantDecimales) {
    var d = parseFloat(val);
    if (!isNaN(d)) {
        return d.toFixed(cantDecimales ? cantDecimales : 2);
    } else {
        return '';
    }

};

export const formatearPorcentaje = function (val, cantDecimales) {
    var d = parseFloat(val);
    if (!isNaN(d)) {
        return (d * 100).toFixed(cantDecimales ? cantDecimales : 2);
    } else {
        return '';
    }

};

const normalizarStr = function (str) {
    return str ? str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().trim() : "";
};

export default {

    getOptionByKey: function (list, key) {
        const objs = list.filter((o) => {
            if (typeof key === "string")
                return o.key.toLowerCase() === key.toLowerCase();
            else
                return o.key === key;
        });
        return (objs && objs.length) > 0 ? objs[0] : null;
    },

    scrollToFirstTooltip: function () {
        var first = $(".invalid").first();
        if (first.length > 0) {
            var top = first.offset().top;
            $('html,body').animate({
                    scrollTop: top - 40
                },
                'slow');
        }
    },

    arrayIndexOf: function (array, key, value) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] == value) {
                return i;
            }
        }
        return -1;
    },

    hasWhiteSpace: function (s) {
        return s.indexOf(' ') >= 0;
    },

    thumbnailify: function (base64Image, targetSize, callback) {
        var img = new Image();

        img.onload = function () {
            var width = img.width,
                height = img.height,
                canvas = document.createElement('canvas'),
                ctx = canvas.getContext("2d");

            canvas.width = canvas.height = targetSize;

            ctx.drawImage(
                img,
                width > height ? (width - height) / 2 : 0,
                height > width ? (height - width) / 2 : 0,
                width > height ? height : width,
                width > height ? height : width,
                0, 0,
                targetSize, targetSize
            );

            callback(canvas.toDataURL());
        };

        img.src = base64Image;
    },
    dataURLtoFile: function dataURLtoFile(dataurl, filename) {

        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, {type: mime});
    },
    actualizarModel: function (model, jsonData) {
        $.each(model, function (k, v) {
            v = jsonData[k];
        });
    },

    isNumber: function (n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    formatAmount: function (value) {
        var val = Number(Math.round(value + 'e2') + 'e-2').toFixed(2);
        return val.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatearDecimal: function (val, cantDecimales) {
        var d = parseFloat(val);
        if (!isNaN(d)) {
            return d.toFixed(cantDecimales ? cantDecimales : 2);
        } else {
            return '';
        }

    },

    calculateAge: function (strBirthdate) {
        var from = strBirthdate.split("/");
        var f = new Date(from[2], from[1], from[0]);
        var ageDifMs = Date.now() - f.getTime();
        var ageDate = new Date(ageDifMs);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    },

    isInteger: function (str) {
        if (Math.floor(str) === Number(str) && $.isNumeric(str)) {
            return true;
        }
        return false;
    },


    formatDatePicker: function (d) {
        var month = d.getMonth() + 1;
        var day = d.getUTCDate(); //fix
        var output =
            (day < 10 ? '0' : '') + day + '/' +
            ((month < 10 ? '0' : '') + month) + '/' +
            d.getFullYear();
        return output;
    },

    parseDate: function (strDate) {
        if (!strDate) return null;
        var from = strDate.split("/");
        var d = new Date(from[2], parseInt(from[1]) - 1, from[0]);
        return d;
    },

    /*obtiene valores del objeto para realizar busqueda*/
    obtenerArregloValores: function (obj) {
        var arrValores = [];
        for (const prop in obj) {
            if (obj[prop]) {
                if (typeof obj[prop] == 'string') {
                    arrValores.push(normalizarStr(obj[prop]));
                } else {
                    if (typeof obj[prop] == 'number') {
                        arrValores.push(formatearDecimal(obj[prop]));
                    }
                }
            }
        }
        return arrValores;
    },

    contieneSimilar: function (arrValores, keyword) {
        return arrValores.filter(function (el) {
            return el.indexOf(normalizarStr(keyword)) >= 0;
        }).length > 0;
    },


    getTipoDocumentoById: function (id) {
        var label = null;
        $.each(TipoDocumentoEnum, function (k, obj) {
            if (id === obj.id) {
                label = obj.label;
            }
        });
        return label;
    },
    isEmpty: function (value) {
        return (typeof value === "undefined" || value === null)
    },
    getFileName: function (response) {
        const contentDisposition = response.headers['content-disposition'];
        return contentDisposition.substr(contentDisposition.indexOf('filename=') + 9);
    },
    getHgClass: function (idx) {
        const pos = Math.floor(idx / 4);
        if (idx === 4 * (pos + 1) - 4)
            return 1;
        else if (idx === 4 * (pos + 1) - 3)
            return 2;
        else if (idx === 4 * (pos + 1) - 2)
            return 3;
        else if (idx === 4 * (pos + 1) - 1)
            return 4;
    },

}




// WEBPACK FOOTER //
// ./src/util/util.js